// @ts-nocheck
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

const getUniversalDateTimeFormat = ({ dateTime }) => {
  if (dateTime) {
    return `${dayjs(dateTime)?.format?.("ddd")} ${dayjs(dateTime)?.format?.("MM/DD/YYYY")}`;
  } else {
    return null;
  }
};

function getAbbr(str) {
  if (typeof str === "string") {
    return str
      .split(/\s+/)
      .map((word) => word[0]?.toUpperCase() || "")
      .join("");
  } else {
    return str;
  }
}

const getUniversalDateWithTimeFormat = ({ dateTime }) => {
  if (dateTime) {
    const timezone = dayjs(dateTime)?.format("zzz");
    return `${dayjs(dateTime)?.format?.("ddd MM/DD/YYYY [at] hh:mm a")} (${getAbbr(timezone)})`;
  } else {
    return null;
  }
};

const getUniversalDateWithTimeFormatForChat = ({ dateTime }) => {
  if (dateTime) {
    const timezone = dayjs(dateTime)?.format("zzz");
    // return `${dayjs(dateTime)?.format?.("Do MMM YY [at] hh:mm a")} (${getAbbr(timezone)})`;
    return `${dayjs(dateTime)?.format?.("hh:mm a, MM/DD/YY")}`;
  } else {
    return null;
  }
};

const getUniversalTimeFormat = ({ dateTime }) => {
  if (dateTime) {
    const timezone = dayjs(dateTime)?.format("zzz");
    return `${dayjs(dateTime)?.format?.("hh:mm A")} (${getAbbr(timezone)})`;
  } else {
    return null;
  }
};

export {
  getUniversalDateTimeFormat,
  getUniversalDateWithTimeFormat,
  getUniversalTimeFormat,
  getUniversalDateWithTimeFormatForChat,
};